import { motion } from 'framer-motion';
import { processSteps } from '../data/services';

const ProcessSection = () => {
  return (
    <section data-testid="process-section" className="py-20 md:py-32 lg:py-40">
      <div className="container-wide">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16 md:mb-24"
        >
          <span className="eyebrow mb-4 block">Process</span>
          <h2 className="text-display font-['DM_Sans']">
            How we work
          </h2>
        </motion.div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {processSteps.map((step, index) => (
            <motion.div
              key={step.number}
              data-testid={`process-step-${step.number}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="relative"
            >
              {/* Number */}
              <div className="mb-6">
                <span className="text-6xl md:text-7xl font-light text-border font-['DM_Sans']">
                  {step.number}
                </span>
              </div>

              {/* Content */}
              <div>
                <h3 className="text-xl md:text-2xl font-medium tracking-tight font-['DM_Sans'] mb-3">
                  {step.title}
                </h3>
                <p className="text-muted-foreground text-sm">
                  {step.description}
                </p>
              </div>

              {/* Connector line (hidden on last item and mobile) */}
              {index < processSteps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-px bg-border -translate-x-4" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
